module.exports = __webpack_public_path__ + "static/img/bg_card.a4c86b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xmasSaled-2025/bg_card.png
// module id = gLui
// module chunks = 1